import Landing from 'library/src/core/landing_v2'

export default class VueLanding extends Landing {
    static install (Vue, options) {
        Object.defineProperties(Vue.prototype, {
            $landing: {
                get () { return this.$root._landing }
            },
            $json: {
                get () { return this.$root._json }
            }
        })

        Vue.mixin({
            beforeCreate () {
                if (this.$parent === undefined) {
                    Vue.util.defineReactive(this, '_json', null)
                } else if (this.$parent === this.$root) {
                    this.$root._landing = new VueLanding(this.$root, options, this.$options.propsData)
                }
            }
        })
    }

    constructor (app, options, propsData) {
        super({
            ...options,
            propsData
        })

        if (Array.isArray(options.additionalProps)) {
            options.additionalProps.forEach(additionalProp => Object.assign(this, {
                [additionalProp]: propsData[additionalProp]
            }))
        }

        this.getJSON()
            .then(json => {
                app._json = json
            })
    }
}
